import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InviteComponent } from './invite/invite.component';
import { InvitefirmComponent } from './invitefirm/invitefirm.component';
import { InvitecontactsComponent } from './invitecontacts/invitecontacts.component';
import { InvitesentComponent } from './invitesent/invitesent.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    InviteComponent,
    InvitefirmComponent,
    InvitecontactsComponent,
    InvitesentComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ]
})
export class InvitesModule { }
